import { createFileRoute } from '@tanstack/react-router';
import { observer } from 'mobx-react-lite';

export const Route = createFileRoute('/(authenticated)/about/')({
  component: AboutPageWrapper,
});

const AboutPage = observer(() => {
  return (
    <div className="flex flex-col w-full max-w-5xl mx-auto p-6 dark:bg-dark h-full">
      <div className="mb-8">
        <h1 className="text-2xl  mb-2">About</h1>
        <p className="text-muted-foreground">
          Paddock is a platform for managing your deals.
        </p>
      </div>

      {/* Slack Integration */}
      <div className="mb-10">
        <div className="flex items-center mb-2">
          <h2 className="text-lg">Current Font</h2>
        </div>
        <p className="text-sm text-muted-foreground mb-4">
          The current font is `Geist`
        </p>
      </div>
    </div>
  );
});

function AboutPageWrapper() {
  return <AboutPage />;
}
